import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ResponsiveCollapseComponent } from '../../../responsive-collapse/responsive-collapse.component';
import { InhaltConfig } from '../detail-inhalt/inhalt-config';

@Component({
  selector: 'now-wbsuche-lib-detail-kachel',
  templateUrl: './detail-kachel.component.html',
  styleUrls: ['./detail-kachel.component.scss'],
  imports: [ResponsiveCollapseComponent, AsyncPipe]
})
export class DetailKachelComponent {
  @Input({ required: true })
  public title!: string;

  @Input({ required: true })
  public icon!: string;

  @Input({ required: true })
  public id!: string;

  @Input({ required: true })
  public collapseButtonText!: string;

  @Output()
  collapsedChanged = new EventEmitter<boolean>();

  public maxHeight$ = InhaltConfig.getCollapseMaxHeight$();
}
